import { useState } from 'react';

import { Button, DataTable } from '@raystack/apsara';
import { Modal } from '@studio/components';

import { ScrollView } from '@src/components/PixxelUIKit/ScrollView';

import styles from './styles.module.css';

type band = {
  name: string;
  wavelength: number;
};

interface BandList {
  bands: band[];
}

export const BandsList = ({ bands = [] }: BandList) => {
  const [showTable, setShowTable] = useState(false);

  if (bands?.length === 0) return null;

  const columns = [
    {
      accessorKey: 'name',
      header: 'Band Name'
    },
    {
      accessorKey: 'wavelength',
      header: 'Central Wavelength'
    }
  ];

  return (
    <>
      <Button
        variant='text'
        color='neutral'
        className={styles.bandsInfo}
        onClick={() => setShowTable(true)}
        data-test-id='bands-click'
      >
        {bands?.length}
      </Button>
      <Modal
        show={showTable}
        onClose={() => setShowTable(false)}
        title='Bandsets'
        footer={<></>}
      >
        <ScrollView height={400}>
          <DataTable
            columns={columns}
            data={bands}
            defaultSort={{ name: 'name', order: 'asc' }}
          >
            <DataTable.Content />
          </DataTable>
        </ScrollView>
      </Modal>
    </>
  );
};
